import { connect } from 'react-redux'
import {
  selectCurrentSearchConversationIds,
  selectCurrentSearchQueryTotalCount,
} from 'ducks/searches/selectors'
import PagingButtonsView from 'components/ConversationHeader/Buttons/PagingButtons'
import {
  doOpenNextRoomPage,
  doOpenPreviousRoomPage,
} from 'ducks/chat/actions/rooms'

const select = state => ({
  currentConversationIndex: selectCurrentSearchConversationIds(state),
  totalConversations: selectCurrentSearchQueryTotalCount(state),
})

const perform = {
  // eslint-disable-next-line no-console
  openNextConversation: doOpenNextRoomPage,
  // eslint-disable-next-line no-console
  openPreviousConversation: doOpenPreviousRoomPage,
}

export default connect(select, perform)(PagingButtonsView)
